<template>
  <yandex-map
    v-if="coords.length !== 0"
    :coords="coords"
    zoom="9"
    style="width: 100%; height: 600px"
    use-object-manager
    @map-was-initialized="initHandler"
    >
  </yandex-map>

</template>

<script>
import { yandexMap } from "vue-yandex-maps";
import axios from "axios";

function CustomSearchProvider(oms) {
  this.oms = oms;
}

CustomSearchProvider.prototype.geocode = function(request, options) {
  let deferred = new ymaps.vow.Deferred();
  let geoObjects = new ymaps.GeoObjectCollection();
  let offset = options.skip || 0;
  let limit = options.results || 20;
  let points = [];

  for (let i = 0, l = this.oms.length; i < l; i++) {
    let om = this.oms[i];

    om.objects.each(function(p) {
      if (
          p.properties.balloonContentHeader
              .toLowerCase()
              .indexOf(request.toLowerCase()) !== -1
      ) {
        points.push(p);
      }
    });
  }
  // При формировании ответа можно учитывать offset и limit.
  points = points.splice(offset, limit);

  // Добавляем точки в результирующую коллекцию.
  for (let i = 0, l = points.length; i < l; i++) {
    let point = points[i];
    let coords = point.geometry.coordinates;
    let text = point.properties.hintContent;
    geoObjects.add(
        /*eslint no-undef: "error"*/
        new ymaps.Placemark(coords, {
          name: text,
          balloonContentBody: text,
          boundedBy: [coords, coords]
        })
    );
  }

  deferred.resolve({
    // Геообъекты поисковой выдачи.
    geoObjects: geoObjects,
    // Метаинформация ответа.
    metaData: {
      geocoder: {
        // Строка обработанного запроса.
        request: request,
        // Количество найденных результатов.
        found: geoObjects.getLength(),
        // Количество возвращенных результатов.
        results: limit,
        // Количество пропущенных результатов.
        skip: offset
      }
    }
  });

  // Возвращаем объект-обещание.
  return deferred.promise();
};

export default {
  name: "RegionMap",
  components: { "yandex-map": yandexMap },
  props: {
    guest: Boolean,
    regionId: Number,
    activeYear: Number,
    municipalityName: String
  },
  data() {
    return {
      map: {},
      searched: "",
      show: false,
      polygon: null,
      name: "",
      coords: [],
      points: []
    };
  },
  methods: {
    getMapInfo(year, regionId, guest) {
      axios
        .post("/eco-passport/get-map", {year, regionId, guest})
        .then(response => {
          this.coords = response.data.regionCenter
          this.points = response.data.orgPoint
        })
        .catch(e => alert(e.toString()));
    },
    mapBalloon: function() {
      let balloons = {
        type: "FeatureCollection",
        features: []
      };
      this.points.forEach((point, index) => {
        let coords = [];

        coords.push(point.lat);
        coords.push(point.lng);

        let header = point.rawHTMLHeader
        let rawHTMLBody = point.rawHTMLBody

        balloons.features.push({
          type: "Feature",
          id: index,
          geometry: {coordinates: [coords[0], coords[1]], type: "Point"},
          properties: {
            balloonContentHeader: header,
            balloonContentBody: rawHTMLBody,
            clusterCaption: point.orgName,
            hintContent: point.orgName
          },
          options: {
            iconColor: "#504FA0",
            balloonIconImageSize: 100
          },
          clusterName: "1"
        });
      })
      return balloons
    },
    initHandler(map) {
      if (this.municipalityName === "Эвенкийский муниципальный район") {
        this.name = "Эвенкийский район"
      } else if(this.municipalityName === "ЗАТО г. Железногорск") {
        this.name = "Железногорск"
      } else if(this.municipalityName === "Таймырский Долгано-Ненецкий муниципальный район") {
        this.name = "Долгано-Ненецкий"
      } else if (this.municipalityName.split(" ")[0] === "г.") {
        this.name = this.municipalityName.split(" ")[1]
      } else if (this.municipalityName.split(" ")[0] === "п." && this.municipalityName !== "п. Кедровый") {
        this.name = "поселок " + this.municipalityName.split(" ")[1]
      } else {
        this.name = this.municipalityName
      }

      axios
        .get("https://nominatim.openstreetmap.org/search",
            {withCredentials: false, params: {q: this.name, format: "json", polygon_geojson: 1}})
        .then(response => {
          let border = []
          let borderAll = []
          response.data.forEach(item => {
            if ((item.display_name.split(',')[1] === " Красноярский край" || item.display_name.split(',')[2] === " Красноярский край" )
                && (item.type === "administrative" || item.type === "town" || item.type === "city")) {
              if (item.geojson.coordinates.length === 1) {
                item.geojson.coordinates[0].forEach(item => {
                  let point = []
                  point.push(item[1])
                  point.push(item[0])
                  border.push(point)
                })
              } else {
                if (item.geojson.type === "Polygon") {
                  item.geojson.coordinates.forEach(item2 => {
                    item2.forEach(item3 => {
                      let point = []
                      point.push(item3[1])
                      point.push(item3[0])
                      border.push(point)
                    })
                    borderAll.push(border)
                    border = []
                  })
                } else if (item.geojson.type === "MultiPolygon") {
                  item.geojson.coordinates.forEach(item2 => {
                    item2[0].forEach(item3 => {
                      let point = []
                      point.push(item3[1])
                      point.push(item3[0])
                      border.push(point)
                    })
                    borderAll.push(border)
                    border = []
                  })
                }
              }
            }
          })
          if (border.length !== 0) {
            this.polygon = new ymaps.Polygon([border], {
              //Свойства
              hintContent: this.municipalityName
            }, {
              // Опции.
              // Цвет заливки (красный)
              fillColor: '#9393f6',
              // Цвет границ (синий)
              // Прозрачность (полупрозрачная заливка)
              opacity: 0.3,
              // Ширина линии
              strokeWidth: 2,
              // Стиль линии
              strokeStyle: 'shortdash'
            });
            map.geoObjects.add(this.polygon);
          } else {
            borderAll.forEach(item => {
              this.polygon = new ymaps.Polygon([item], {
                hintContent: this.municipalityName
              }, {
                fillColor: '#9393f6',
                opacity: 0.3,
                strokeWidth: 2,
                strokeStyle: 'shortdash'
              });
              map.geoObjects.add(this.polygon);
            })
          }
        })

      let objectManager = new ymaps.ObjectManager({
        clusterize: true,
        // viewportMargin: 512,
        clusterDisableClickZoom: true,
      });

      // Флаг "raw" означает, что данные вставляют "как есть" без экранирования html.
      var customItemContentLayout = ymaps.templateLayoutFactory.createClass();

      // Чтобы задать опции одиночным объектам и кластерам,
      //   обратимся к дочерним коллекциям ObjectManager.
      objectManager.clusters.options.set({
        // Макет метки кластера pieChart.
        clusterIconLayout: "default#pieChart",
        // Радиус диаграммы в пикселях.
        clusterIconPieChartRadius: 15,
        // Радиус центральной части макета.
        clusterIconPieChartCoreRadius: 10,
        // Ширина линий-разделителей секторов и внешней обводки диаграммы.
        clusterIconPieChartStrokeWidth: 3,
        // Определяет наличие поля balloon.
        clusterBalloonItemContentLayout: customItemContentLayout,
        openBalloonOnClick: true,
        clusterBalloonLeftColumnWidth: 120,
        balloonItemContentLayout: "cluster#balloonTwoColumnsItemContent"
      });
      map.geoObjects.add(objectManager);

      // Добавляем контрол в верхний правый угол,
      var mySearchControl = new ymaps.control.SearchControl({
        options: {
          provider: new CustomSearchProvider([objectManager]),
          noPlacemark: true,
          resultsPerPage: 5,
          placeholderContent: "Поиск по организациям"
        }
      });

      map.controls.remove("searchControl");
      map.controls.remove("typeSelector");
      map.controls.remove("rulerControl");
      map.controls.remove("trafficControl");
      map.controls.add(mySearchControl, {float: "right"});

      //Если points не пустые, то в objectManager.add(this.mapBalloon()) идёт добавление поинтов
      //на карту вместе с их данными
      if (this.points !== null) {
        objectManager.add(this.mapBalloon());
      }
    },
  },
  created() {
    this.getMapInfo(this.activeYear, this.regionId, this.guest)
  }
};
</script>

<style scoped>
.v-application .body-1 {
  font-size: 0.85rem !important;
  font-weight: 400;
  letter-spacing: 0.03125em !important;
  line-height: 1.5rem;
  font-family: "Roboto", sans-serif !important;
}
</style>
